import { useMemo } from 'react';
import dayjs from 'dayjs';

import CountDown from '~/components/CountDown';

const TEN_HOUR_MILLISECOND = 36000000;

type Props = {
  lastDeliveryCutoff?: string;
  expectedDeliveryText?: string;
  hasDefaultAddressRegion?: boolean;
};

export function CutoffTimer({
  lastDeliveryCutoff,
  expectedDeliveryText,
  hasDefaultAddressRegion,
}: Props) {
  // 1. 현재 시간 + 1day > 컷오프
  // 2. 현재 시간 + 1day < 컷오프
  const isBefore24Hour = useMemo(() => {
    return !!(
      dayjs().valueOf() + TEN_HOUR_MILLISECOND >=
      dayjs(lastDeliveryCutoff).valueOf()
    );
  }, [lastDeliveryCutoff]);

  const countdown = useMemo(() => {
    if (!lastDeliveryCutoff) return undefined;
    return dayjs(lastDeliveryCutoff).valueOf() - dayjs().valueOf();
  }, [lastDeliveryCutoff]);

  if (!countdown || !expectedDeliveryText) return null;

  return (
    <p className="pt-4 typo-paragraph100-semibold">
      {isBefore24Hour && countdown ? (
        <>
          <CountDown initialTime={countdown} />
          <span className="typo-paragraph100-regular"> 내 주문 시</span>
        </>
      ) : (
        <span className="typo-paragraph100-regular">지금 결제 시</span>
      )}
      &nbsp;
      <span className="text-success-medium">{expectedDeliveryText}</span>
      {!hasDefaultAddressRegion && (
        <span className="ml-4 text-hint typo-footnote300-regular">
          (서울, 경기 기준)
        </span>
      )}
    </p>
  );
}
